import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Clock, Moon } from 'lucide-react';
const steps = [{
  icon: Eye,
  number: '01',
  title: 'Leer las Señales Silenciosas',
  body: 'Aprenderás a detectar los signos de cansancio antes del bostezo — el momento exacto en que tu bebé está listo.'
}, {
  icon: Clock,
  number: '02',
  title: 'Identificar la Ventana Exacta',
  body: 'Cada bebé tiene una ventana biológica de vigilia. Aprenderás a calcularla con precisión según su edad.'
}, {
  icon: Moon,
  number: '03',
  title: 'Actuar en el Momento Preciso',
  body: 'Con el timing correcto, tu bebé se dormirá en minutos — sin llanto, sin estrés, sin horas de balanceo.'
}];
export function MechanismSection() {
  return <section className="relative bg-navy-800 py-20 px-4 overflow-hidden" data-id="element-105">
      <div className="section-divider absolute top-0 left-0 right-0" data-id="element-106" />

      {/* Background decoration */}
      <div className="absolute top-10 right-10 text-gold-500/5 font-playfair text-[200px] font-black leading-none pointer-events-none select-none" data-id="element-107">
        ✦
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-109">
          <p className="font-lato text-gold-400 text-sm font-bold tracking-widest uppercase mb-3" data-id="element-110">
            El Mecanismo Único
          </p>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-cream leading-tight mb-4" data-id="element-111">
            El{' '}
            <span className="gold-gradient-text" data-id="element-112">Protocolo de Ventanas™</span>
          </h2>
          <p className="font-lato text-cream/70 text-lg max-w-xl mx-auto" data-id="element-113">
            El sistema que sincroniza el reloj biológico de tu hijo con la
            naturaleza
          </p>
        </motion.div>

        {/* Science callout */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="rounded-2xl p-8 mb-14 border border-gold-500/30" style={{
        background: 'linear-gradient(135deg, rgba(201,168,76,0.1), rgba(15,31,61,0.9))'
      }} data-id="element-114">
          <p className="font-lato text-cream/80 text-lg leading-relaxed mb-5" data-id="element-115">
            Cuando un bebé pasa más de 15 minutos más allá de su capacidad
            biológica de estar despierto, su cerebro entra en modo{' '}
            <strong className="text-gold-300" data-id="element-116">"alerta"</strong>. Se activa la
            hormona del estrés — y ese es el motivo por el cual, mientras más
            cansado está,{' '}
            <strong className="text-cream" data-id="element-117">más lucha contra el sueño.</strong>
          </p>
          <div className="border-t border-gold-500/20 pt-5" data-id="element-118">
            <p className="font-playfair text-xl md:text-2xl font-bold text-gold-300 italic leading-snug" data-id="element-119">
              "Mi método no enseña a 'dormir'; enseña a identificar el segundo
              exacto en que la biología de tu hijo pide descanso."
            </p>
          </div>
        </motion.div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-120">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.15
          }} className="navy-card rounded-2xl p-7 text-center" data-id="element-121">
                <div className="font-playfair text-5xl font-black gold-gradient-text opacity-30 mb-3" data-id="element-122">
                  {step.number}
                </div>
                <div className="w-12 h-12 rounded-full gold-gradient-bg flex items-center justify-center mx-auto mb-4" data-id="element-123">
                  <Icon size={20} className="text-navy-900" data-id="element-124" />
                </div>
                <h3 className="font-playfair text-lg font-bold text-cream mb-3" data-id="element-125">
                  {step.title}
                </h3>
                <p className="font-lato text-cream/70 text-sm leading-relaxed" data-id="element-126">
                  {step.body}
                </p>
              </motion.div>;
        })}
        </div>
      </div>

      <div className="section-divider absolute bottom-0 left-0 right-0" data-id="element-127" />
    </section>;
}